module.exports = __webpack_public_path__ + "static/media/bKash_Logo_button.13e0bb33.svg";